"use client"

import React from 'react'
import { useCurrentSearchParams } from '@/shared/hooks/use-current-search-params'
import { GetHomeOwnerQueryParamsType } from '../schema/home/query-params.schema'

function HomeOwnersResultsCount({ total, isLoading }: { total: number, isLoading: boolean }) {
    const currentParams = useCurrentSearchParams<GetHomeOwnerQueryParamsType>([
        "overallStatus",
        "reliefStatus",
        "rebuildingStatus",
        "goodwillStatus",
        "medicalNeeds",
        "homeownerAge",
        "isSingleParent",
        "numChildrenUnder18",
        "isFirstResponder",
        "isVeteran",
        "hasFloodInsurance",
        "hasHomeInsurance",
        "femaStatus",
        "sbaStatus",
        "residenceType",
        "structureType",
        "assessmentCompleted",
        "search",
    ])

    // Check if any filters are active
    const activeFilters = Object.entries(currentParams).filter(([key, value]) => 
        value !== undefined && 
        value !== null && 
        value !== '' && 
        value !== 'undefined'
    )

    if (isLoading) {
        return (
            <div className="text-sm text-muted-foreground">
                Loading…
            </div>
        )
    }

    if (activeFilters.length === 0) {
        return (
            <div className="text-sm text-muted-foreground font-bold">
                Showing {total.toLocaleString()} homeowners
            </div>
        )
    }

    // Create a summary of active filters
    const filterSummary = activeFilters
        .map(([key, value]) => {
            const displayNames: Record<string, string> = {
                overallStatus: 'Overall Home Status',
                reliefStatus: 'Relief Status',
                rebuildingStatus: 'Rebuilding Status',
                goodwillStatus: 'Goodwill Status',
                medicalNeeds: 'Special (Medical) Needs',
                homeownerAge: 'Homeowner Age',
                isSingleParent: 'Single Parent',
                numChildrenUnder18: 'Children Under 18',
                isFirstResponder: 'First Responder',
                isVeteran: 'Veteran',
                hasFloodInsurance: 'Flood Insurance',
                hasHomeInsurance: 'Home Insurance',
                femaStatus: 'FEMA Status',
                sbaStatus: 'SBA Status',
                residenceType: 'Residence Type',
                structureType: 'Structure Type',
                search: 'Search',
            }
            return `${displayNames[key] || key}: ${value}`
        })
        .join(', ')

    return (
        <div className="text-sm text-muted-foreground">
            <span className="font-bold">Showing {total.toLocaleString()} homeowners</span>
            {activeFilters.length > 0 && (
                <span className="font-medium">
                    {' '}filtered by {filterSummary}
                </span>
            )}
        </div>
    )
}

export default HomeOwnersResultsCount 
